import gql from 'graphql-tag';
import CLASSROOM_USER_ENROLLMENT_FRAGMENT from 'graph/fragments/classroom-user-enrollment';
import { KEYBOARDING_CLASSROOM_EXPORT_FRAGMENT_LEGACY } from 'graph/fragments/keyboarding-classroom-export';
import { KEYBOARDING_STUDENT_EXPORT_FRAGMENT_LEGACY } from 'graph/fragments/keyboarding-student-export';

const KEY_EXPORT_CLASSROOM_REPORT_QUERY = gql`
  query getClassroomReportExporting($id: Int!, $dateRange: DateRangeInput!) {
    classroom: keyClassroomExportReport(where: { classroomId: $id }, dateRange: $dateRange) {
      ...BaseKeyboardingClassroomExportLegacy
      classroom {
        users {
          ...BaseClassroomUserEnrollment
        }
      }
    }
    students: keyClassroomEngagementReport(where: { classroomId: $id }, dateRange: $dateRange) {
      ...BaseKeyboardingStudentExportLegacy
    }
  }
  ${KEYBOARDING_CLASSROOM_EXPORT_FRAGMENT_LEGACY}
  ${CLASSROOM_USER_ENROLLMENT_FRAGMENT}
  ${KEYBOARDING_STUDENT_EXPORT_FRAGMENT_LEGACY}
`;

export default KEY_EXPORT_CLASSROOM_REPORT_QUERY;
